import { mapAvailableFeatures } from 'modules/organizer/domain/data-mappers/available-feature.data-mapper';
import { Feature, FeatureDto } from 'modules/organizer/domain/interfaces/available-feature';
import { baseApi } from 'shared/api/base-api';
import { ResponseError } from 'shared/types/response-errors';
import { parseResponseError } from 'shared/utils';

const availableFeaturesQuery = `#graphql
  query getMyFeatures($id: Int!) {
    features(tournamentId: $id) {
      feature
      isEnabled
    }
  }
`;

interface AvailableFeaturesError {
  status?: number;
  data?: unknown;
  message?: string;
}

/**
 * Фичи тарифа организации — по ним открываются платные разделы (меню, роуты, вкладка «Медиа»).
 *
 * Раньше запрос жил в react-query с бессрочным кэшем, и после оплаты тарифа разделы
 * оставались закрытыми до F5 (IMGM-1510). Теперь кэш помечен тегом `AvailableFeature`,
 * и его сбрасывают оплата тарифа (`buyPlan`) и подтверждённое пополнение
 * (`use-subscription-billing.ts`) — пополнение может само оплатить подписку.
 *
 * Аргумент — id организации (backend `tournamentId`).
 */
const availableFeaturesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAvailableFeatures: build.query<Feature, number>({
      query: (organizerId) => ({ query: availableFeaturesQuery, variables: { id: organizerId } }),
      transformResponse: (raw: { features: FeatureDto[] }) => mapAvailableFeatures(raw.features),
      // Внутренняя ошибка сервера прячет причину в `extensions.debugMessage` — как и прежний репозиторий.
      transformErrorResponse: (error: AvailableFeaturesError) => {
        const [first] = Array.isArray(error.data) ? (error.data as ResponseError[]) : [];
        if (!first?.message) return error;
        return { ...error, message: first.extensions ? parseResponseError(first) : first.message };
      },
      providesTags: ['AvailableFeature'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetAvailableFeaturesQuery } = availableFeaturesApi;

export default availableFeaturesApi;
